var React = require('react');

function RadioOn (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"9","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"M8 12.7L10.4 15.1L16 9.5","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","key":1})]);
}

RadioOn.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = RadioOn;

RadioOn.default = RadioOn;
